export default "__VITE_ASSET__c0b03b0d__"